export const urls = [
	"/community-insights",
	"/street-insights",
	"/incentive-insights",
	// "/",
	// "/national-insights"
];
